import React, { useEffect, useState } from 'react';
import { Leaf } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const About = () => {
  const [content, setContent] = useState({
    about_intro: null,
    what_we_offer: null,
    why_choose_us: null,
    our_vision: null
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/site-content`);
        const contentMap = {};
        response.data.forEach(item => {
          contentMap[item.section] = item;
        });
        setContent(contentMap);
      } catch (error) {
        console.error('Error fetching site content:', error);
      }
    };
    fetchContent();
  }, []);

  return (
    <div className="bg-white min-h-screen pt-20">
      {/* Header */}
      <section className="py-16 px-4 bg-gradient-to-r from-emerald-600 to-green-700">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-white mb-4">
            {content.about_intro?.title || 'About Us'}
          </h1>
          <div className="h-1 w-32 bg-amber-400 mx-auto"></div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-16">
        {/* Introduction */}
        {content.about_intro && (
          <div className="mb-16">
            {content.about_intro.content.split('\n\n').map((para, idx) => (
              <p key={idx} className="font-body text-lg text-gray-700 leading-relaxed mb-6">
                {para}
              </p>
            ))}
          </div>
        )}

        {/* What We Offer */}
        {content.what_we_offer && (
          <div className="bg-emerald-50 rounded-2xl p-8 mb-16">
            <h2 className="font-heading text-3xl text-navy mb-6 flex items-center">
              <Leaf size={32} className="text-emerald-600 mr-3" />
              {content.what_we_offer.title}
            </h2>
            <ul className="space-y-4">
              {content.what_we_offer.content.split('|').map((item, idx) => (
                <li key={idx} className="flex items-start space-x-3">
                  <span className="text-emerald-600 text-2xl font-bold mt-1">✓</span>
                  <span className="font-body text-lg text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Why Choose Us */}
        {content.why_choose_us && (
          <div className="mb-16">
            <h2 className="font-heading text-3xl text-navy mb-6 flex items-center">
              <span className="text-emerald-600 mr-3 text-4xl">🐅</span>
              {content.why_choose_us.title}
            </h2>
            {content.why_choose_us.content.split('\n\n').map((para, idx) => (
              <p key={idx} className="font-body text-lg text-gray-700 leading-relaxed mb-4">
                {para}
              </p>
            ))}
          </div>
        )}

        {/* Our Vision */}
        {content.our_vision && (
          <div className="bg-gradient-to-r from-emerald-600 to-green-700 rounded-2xl p-10 text-white">
            <h2 className="font-heading text-4xl mb-6">
              {content.our_vision.title}
            </h2>
            {content.our_vision.content.split('\n\n').map((para, idx) => (
              <p key={idx} className="font-body text-xl leading-relaxed mb-4">
                {para}
              </p>
            ))}
          </div>
        )}

        {/* Admin Note */}
        <div className="mt-12 p-6 bg-blue-50 border-2 border-blue-200 rounded-xl">
          <p className="font-body text-sm text-blue-800 text-center">
            💡 <strong>Admin:</strong> You can edit this content from Admin Dashboard → Site Content
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
